import { handleResponse, exception, getAuthHeadersForMethod } from "./utils";
import { getFormattedMessage } from "../components/utils";

export const getLogs = (queryParams, authToken) => {
  let requestOptions = getAuthHeadersForMethod("GET", authToken);
  const paramString = new URLSearchParams(queryParams);
  const baseUrl = process.env.REACT_APP_API_BASE_URL
  return fetch(
    baseUrl + `logs?${paramString.toString()}`,
    requestOptions
  ).then(handleResponse)
    .catch(err => {
      if (String(err) === "TypeError: Failed to fetch")
        return exception(getFormattedMessage("error-unable-to-connect"))
      return exception(String(err))
    })
};

export const getIpLogs = (queryParams, authToken) => {
  let requestOptions = getAuthHeadersForMethod("GET", authToken);
  const paramString = new URLSearchParams(queryParams);
  const baseUrl = process.env.REACT_APP_API_BASE_URL
  return fetch(
    baseUrl + `ip-logs?${paramString.toString()}`,
    requestOptions
  ).then(handleResponse)
    .catch(err => {
      if (String(err) === "TypeError: Failed to fetch")
        return exception(getFormattedMessage("error-unable-to-connect"))
      return exception(String(err))
    })
};
